import React from 'react'
import HistoryTextBox from './HistoryTextBox'
import HistoryViewButton from './HistoryViewButton'
import allImgPaths from 'assets/images'
import HistoryFileUpload from './HistoryFileUpload';
import { format } from 'date-fns';

interface FileManagementProps {
    activityIcon?: any;
    data: any;
    period: any
}

const FileManagement = ({ activityIcon, data, period }: FileManagementProps) => {
    const handleImageError = (e: any) => {
        e.target.src = allImgPaths.defaultProfile
    }

    const formatFileSize = (size: number) => {
        if (size) {
            if (size < 1024) {
                return `${size} bytes`;
            } else if (size < 1024 * 1024) {
                return `${(size / 1024).toFixed(2)} KB`;
            } else if (size < 1024 * 1024 * 1024) {
                return `${(size / (1024 * 1024)).toFixed(2)} MB`;
            } else {
                return `${(size / (1024 * 1024 * 1024)).toFixed(2)} GB`;
            }
        }
        return ''
    };

    return (
        <>
            <div className="px-3 pt-3 pb-4 mb-5 last:pb-3 last:mb-0 border-b border-[#F1F1F1] last:border-b-transparent">
                <div className="flex gap-x-4 mb-4">
                    <div className="relative w-10">
                        <img className="min-w-10 h-10 rounded-full" onError={handleImageError} src={data?.user?.profile_image || allImgPaths.defaultProfile} alt="" />
                        <img
                            className="absolute top-7 -right-1 w-5 h-5 rounded-full"
                            src={allImgPaths.historyUploaded}
                            alt=""
                        />
                    </div>

                    <div className="leading-none">
                        <div className="font-interMedium text-base text-[#4F4D55] pb-0.5">
                            <span className="font-interMedium text-base text-[#0A090B]">
                                {data?.action_data?.action_user?.name || 'A user'}
                            </span>
                            {
                                !data?.action_data?.item || data?.action_data?.item == 'file-upload' &&
                                <span> uploaded file to task </span>
                            }
                            {
                                !data?.action_data?.item || data?.action_data?.item == 'file-download' &&
                                <span> downloaded a file to task </span>
                            }
                            <span className="font-interMedium text-base text-[#1751D0]"> {data?.task?.title} </span>

                        </div>
                        <div className="leading-none flex items-center gap-x-2.5">
                            {
                                (period == 'Today' || period == 'Yesterday') &&
                                <span className="text-xs text-[#7F7D83]">
                                    {format(data?.createdAt, 'hh:mm a')}
                                </span>
                            }
                            {
                                period != 'Today' && period != 'Yesterday' &&
                                <span className="text-xs text-[#7F7D83]">
                                    {format(data?.createdAt, 'EEEE, MMM dd yyyy, hh:mm a')}
                                </span>
                            }
                            <span className="w-1 h-1 bg-[#7F7D83] rounded-full block"></span>
                            <span className="text-xs text-[#7F7D83]">
                                {/* Guest Management / Special guests and speakers */}
                                {data?.block?.title} / {data?.card?.title}
                            </span>
                        </div>
                    </div>
                </div>

                <HistoryFileUpload
                    fileName={
                        data?.action_data?.new_value?.file?.name || 
                        data?.action_data?.new_value?.title
                    }
                    fileSize={
                        formatFileSize(data?.action_data?.new_value?.file?.size || null)
                    }
                />
            </div>
        </>
    )
}

export default FileManagement